import { useEffect } from 'react';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';
import { EMAIL_SLIDE, PLAN_LOADER_SLIDE, PROFILE_SLIDE_COMPONENT, QUESTION_ANSWER_SLIDE_COMPONENT, QUESTION_MULTI_ANSWER_SLIDE_COMPONENT, TRUST_SLIDE, USER_MIX_SUMMARY_SLIDE } from './quiz-component-types';

const QUESTION_NUMBER_1 = 1;

function useSlideEventsV2({ currentSlideIndex, currentSlide, results }) {
    useEffect(() => {
        logEvent(EVENT_TYPES.QUIZ_PAGE_VISITED);
    }, []);

    useEffect(() => {
        if (!results.email && !currentSlide.isNotIndexing) {
            logEvent(EVENT_TYPES.QUIZ_QUESTION_VISITED, { questionNumber: currentSlideIndex });
        }
    }, [currentSlideIndex]);

    useEffect(() => {
        if (currentSlide.component === TRUST_SLIDE) {
            logEvent(EVENT_TYPES.TRUST_PAGE_VISITED);
        }

        if (currentSlide.component === USER_MIX_SUMMARY_SLIDE) {
            logEvent(EVENT_TYPES.QUIZ_INTRO1_PAGE_VISITED);
        }

        if (currentSlide.component === PROFILE_SLIDE_COMPONENT) {
            logEvent(EVENT_TYPES.PROFILE_PAGE_VISITED);
        }

        if (currentSlide.component === PLAN_LOADER_SLIDE) {
            logEvent(EVENT_TYPES.PLAN_LOADER_PAGE_VISITED);
        }

        if (currentSlide.component === EMAIL_SLIDE) {
            logEvent(EVENT_TYPES.EMAIL_PAGE_VISITED);
        }
    }, [currentSlide.component]);

    const logQuizLifecycle = isLast => {
        if (currentSlide.component === QUESTION_ANSWER_SLIDE_COMPONENT || currentSlide.component === QUESTION_MULTI_ANSWER_SLIDE_COMPONENT) {
            if (currentSlideIndex === QUESTION_NUMBER_1) {
                logEvent(EVENT_TYPES.QUIZ_STARTED);
            }

            if (isLast) {
                logEvent(EVENT_TYPES.QUIZ_COMPLETED);
            }
        }
    };

    return {
        logQuizLifecycle
    };
}

export {
    useSlideEventsV2
};
